import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const staff: RouteRecordRaw = {
  name: 'admin.staff',
  path: 'staff',
  component: () => import('pages/Staff.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.SuperAdmin,
    ],
    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
